import type { IconWeight } from "@phosphor-icons/react/dist/lib/types";

/**
 * Calendar with an info badge. Phosphor has no equivalent, so this one stays
 * hand-drawn.
 *
 * Props match the icon-slot contract that ui-core's `Icon` and `Button` pass
 * down (className for sizing, weight which a fixed drawing ignores), the same
 * shape as ui-core's own StarFilledIcon. Hand it to `<Icon icon={...}>` rather
 * than rendering it directly, so it picks up the shared size and colour scale.
 */
export function BookShipmentCalendarInfoIcon(props: {
  className?: string;
  weight?: IconWeight;
}) {
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        fill="currentColor"
        d="M11.5 6H2v5.5A2.5 2.5 0 0 0 4.5 14h2.1a5.5 5.5 0 0 1 4.9-8M14 4.5A2.5 2.5 0 0 0 11.5 2h-7A2.5 2.5 0 0 0 2 4.5V5h12zm-3.125 5a.625.625 0 1 1 1.25 0a.625.625 0 0 1-1.25 0m1.125 4a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 1 0zm-5-2a4.5 4.5 0 1 1 9 0a4.5 4.5 0 0 1-9 0m8 0a3.5 3.5 0 1 0-7 0a3.5 3.5 0 0 0 7 0"
      />
    </svg>
  );
}
